import React from 'react';
import { Clock } from 'lucide-react';

interface CountdownDisplayProps {
  remaining: number;
  label: string;
  isDarkMode: boolean;
}

export const CountdownDisplay: React.FC<CountdownDisplayProps> = ({ remaining, label, isDarkMode }) => {
  const isUrgent = remaining <= 2;
  const isWarning = remaining <= 4 && remaining > 2;

  return (
    <div className={`px-4 py-3 flex items-center justify-between border-b transition-all ${
      isUrgent 
        ? (isDarkMode ? 'bg-red-900 border-red-700 animate-pulse' : 'bg-red-100 border-red-300 animate-pulse')
        : isWarning
        ? (isDarkMode ? 'bg-yellow-900 border-yellow-700' : 'bg-yellow-100 border-yellow-300')
        : (isDarkMode ? 'bg-blue-900 border-blue-700' : 'bg-blue-100 border-blue-300')
    }`}>
      <div className="flex items-center gap-2">
        <Clock size={18} className={
          isUrgent 
            ? (isDarkMode ? 'text-red-400' : 'text-red-600')
            : isWarning
            ? (isDarkMode ? 'text-yellow-400' : 'text-yellow-600')
            : (isDarkMode ? 'text-blue-400' : 'text-blue-600')
        } />
        <span className={`text-sm font-medium ${
          isUrgent 
            ? (isDarkMode ? 'text-red-200' : 'text-red-800')
            : isWarning
            ? (isDarkMode ? 'text-yellow-200' : 'text-yellow-800')
            : (isDarkMode ? 'text-blue-200' : 'text-blue-800')
        }`}>
          {label}
        </span>
      </div>
      <div className={`text-2xl font-bold ${
        isUrgent 
          ? (isDarkMode ? 'text-red-400' : 'text-red-600')
          : isWarning
          ? (isDarkMode ? 'text-yellow-400' : 'text-yellow-600')
          : (isDarkMode ? 'text-blue-400' : 'text-blue-600')
      }`}>
        {remaining}
      </div>
    </div>
  );
};
